import React from "react";

const LabelValuePair = ({ label, value, className = "", style = {} }) => {
  return (
    <span className={className} style={style}>
      <span style={{ color: "black", fontWeight: "500" }}>{label}</span> :{" "}
      {value}
    </span>
  );
};

export default LabelValuePair;
